import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, } from '@angular/forms';
import { WebServiceService } from 'app/web-service.service';
import { ToastrService } from 'ngx-toastr';
import { MustMatch } from 'app/_helpers/must-match.validators';
import { AuthService } from 'app/shared/auth/auth.service';
import swal from 'sweetalert2';

@Component({
    selector: 'app-chgpwd',
    templateUrl: './change-password.html'

})

export class ChangePwdComponent implements OnInit{
    changePasswordForm : FormGroup;
    submitted = false;
    userDetails : any;
    loginData : any;
    passwordId: any;
    userData: any;
    urlParams:any;
    showForgotPWD=false;
  forgotPasswordForm: FormGroup;
    constructor(
        // private route: ActivatedRoute,
        public authService:AuthService,
        private router: Router,
        private _formBuilder: FormBuilder,
        private service: WebServiceService,
        private toastrService: ToastrService,
        private activatedRoute: ActivatedRoute) {
          // subscribe to router event
          // this.activatedRoute.queryParams.subscribe((params: Params) => {
            // console.log(params);
          // });
          this.urlParams= this.activatedRoute.snapshot.queryParams.encryptedKey
        }

      initilizedData(){

        this.changePasswordForm = new FormGroup({ 
          email: new FormControl ('', [Validators.required,Validators.email]),
          oldPassword: new FormControl ('', [Validators.required], ),
          newPassword:new FormControl('', [Validators.required]),
        })

        this.forgotPasswordForm = new FormGroup({
          emails:new FormControl ('',[Validators.required,Validators.email]),
          password: new FormControl('', [
            Validators.required,
            Validators.pattern(/^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&~,.<>_-]).{6,}$/)
          ]),
          confirmPassword: new FormControl ('',[ Validators.required]),
        });
      }
      // get f() { return this.changePasswordForm.controls; }
      get f() { return this.changePasswordForm.controls; }
      get af() {
        return this.forgotPasswordForm.controls;
      }

  forgot_pwd(){

 this.submitted = true;
  
let userDetails = {
  "forgotMailDtlsId":this.userData.id,
	"email":this.userData.userName,
	"password": this.forgotPasswordForm.value.password,
	"confirmPassword":this.forgotPasswordForm.value.confirmPassword
}
this.service.httpLoginPost('forgot/password',userDetails).subscribe((result:any)=>{
      if(result.success==true)
       {
            this.toastrService.success("Password Changed successfully");
        //  sessionStorage.setItem("EmailID",this.loginData.email)
        this.authService.logout();
        this.router.navigate(['login']);

        }else{
          swal(
            'ERROR!',
            result.message,
            'warning'
          )

           this.initilizedData();
        }
    })

 } 

 change_pwd() {
  let userDetails = {
    "id":this.userData.user_id,
    'email':this.userData.UserName,
    'oldPassword' :this.changePasswordForm.value.oldPassword,
    'newPassword' : this.changePasswordForm.value.newPassword,
  }

  this.service.httpPost('/changePassword',userDetails).subscribe((result:any)=>{
    if(result.success==true){
          this.toastrService.success("Password Changed successfully");
      //  sessionStorage.setItem("EmailID",this.loginData.email)
      this.authService.logout();
      this.router.navigate(['login']);

      }else{
        swal(
          'ERROR!',
          result.message,
          'warning'
        )

         this.initilizedData();
      }

    })
  }



    ngOnInit() {

      if(this.urlParams){
        this.showForgotPWD=true;
        
        this.service.httploginGet('forgot/password?encryptedUserKey='+ this.urlParams).subscribe((data:any)=>{
            // console.log(data,"data");
            if(data.success) {  
              this.userData=data.data;
              sessionStorage.setItem('currentUser',JSON.stringify(data.data))
            } else {
              swal(
                'ERROR!',
                data.message,
                'warning'
              )

            }
            })
      }else{
        this.userData=JSON.parse(sessionStorage.getItem('currentUser'));
        this.showForgotPWD=false;
       
      }
      this. initilizedData();
    //   if ((sessionStorage.getItem('currentUser'))!=null) {
    //     this.router.navigateByUrl('/home');
    //   }

    }
    onCancel(){
        this.router.navigateByUrl('/home');
    }
}



// WEBPACK FOOTER //
// ./src/app/change-pwd/change-password-component.ts